import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useHistory  } from 'react-router-dom';
import '../App.css';
import testJson from '../test/testJson/device_list_test.json';
import { Storage } from 'aws-amplify';
import Amplify, {Auth} from 'aws-amplify';
import API_GATEWAY from "./hostname";
import Pagination from './pagination/Pagination.js';
import loadimg from "../images/loading.gif";

const getIdToken = () =>{
    return new Promise((resolve, reject) => {
        try{
            Auth.currentSession().then((data) => {
                return resolve(data.getIdToken().getJwtToken());
              });
        }
        catch(e){
            console.log('Not signed in');
            return reject('ID取得失敗')
        }  
    })
  
}
function Dsk_list() {
    const [dskLinks, setDskLinks] = useState([]);
    const [authType, setAuthType] = useState('');
    const [redisp, setRedisp] = useState(false);
    const [hotelName, setHotelName] = useState('');
    const numOfLine = 10;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        isAdmin();
        if(location.state){
            setHotelName(location.state.hotelName)
        }
        else{
            history.push({
                pathname: "/",
            });
        }
    },[])
    useEffect(() => {
        if (authType != ''){
            // DSK一覧のリンクを取得
            getDskLinks()
                    .then(result => {
                        setDskLinks(result.keyList)
                        setLoading(false)
                    }).catch(error => {
                        console.error("DSK一覧リンク作成失敗")
                        setLoading(false)
                    })
        }
    },[authType, redisp])

    
    async function handleDeleteClick(e: React.MouseEvent){
        e.preventDefault(); // フォーム送信を抑止
        const dsk_id = e.target.id;
        if (!window.confirm(dsk_id + "を削除しますか？")){
            return;
        }
        getIdToken()
        .then(result => {
            const method = "DELETE";
            const headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':result
            };
            const deleteLockUrl = API_GATEWAY + "/console/v1/devices/dsks/"+ location.state.hotelID + "/" + dsk_id;
            fetch(deleteLockUrl,
            {method:method, headers:headers})
            .then(res => {
                if (res.ok){
                    console.log("fetch実行完了")
                    // リストを再設定
                    setRedisp(!redisp);
                    return true;
                }else{
                    console.log("エラー")
                    alert("削除中にエラーが起きました")
                }})
                .catch(err => {
                    console.log("fetch失敗")
                    alert("削除中にエラーが起きました")
                })
        }).catch(error => {
            console.error("IDトークン取得失敗")
        });
        return false;
    }

    const getDskLinks = () =>{
        return new Promise((resolve, reject) => {
            try{
                getIdToken()
                .then(result => {
                    const method = "GET";
                    const headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':result
                      };
                    var url = API_GATEWAY + "/console/v1/devices/dsks/"+ location.state.hotelID;

                    fetch(url,
                    {method:method, headers:headers})
                    .then((res)=> res.json())
                      .then(data => {
                        console.log("DSK一覧取得のfetch実行完了")
                        var keyList = [];
                        for(var i in data.dsks){
                            keyList.push(
                            <tr>
                                <td class="table_border_updown_thtd_left_number">
                                    {Number(i)+1}
                                </td>
                                <td class="table_border_updown_thtd_right">
                                    {data.dsks[i]}
                                </td>
                                {authType == 'admin' &&
                                <td class="table_border_updown_thtd_right">
                                    <button class="button" type="submit" id={data.dsks[i]} value="削除" onClick={handleDeleteClick.bind(this)}>削除</button>
                                </td>}
                            </tr>
                            );
                        }
                        // ページネーション用。リストの数が１ページ表示行数より多い時の処理。
                        if(keyList){
                            if(numOfLine < keyList.length){
                                const amari = keyList.length % numOfLine;
                                const blank_tr_count = numOfLine - amari;
                                if(amari != 0){
                                    for(var l=0;l<blank_tr_count;l++){
                                        keyList.push(<tr></tr>)
                                    }   
                                }
                            }
                        }
                        const list = {"keyList":keyList};
                        return resolve(list);
                      },[])
                      .catch(err => {
                        console.log("DSK一覧取得のfetch失敗")
                        alert("DSK一覧情報の取得に失敗しました")
                        return reject('DSK一覧取得失敗')
                        })
                }).catch(error => {
                    console.error("IDトークン取得失敗")
                    return reject('IDトークン取得失敗')
                })
            }
            catch(e){
                console.log('DSK一覧取得失敗');
                return reject('DSK一覧取得失敗')
            }  
        })
      
    }

    const history = useHistory();
    const location = useLocation();

    async function isAdmin(){
        try{
            const user = await Auth.currentUserPoolUser();
            const attrs = await Auth.userAttributes(user);
            attrs.forEach(function(attr){
                if (attr.Name == 'custom:authority'){
                    setAuthType(attr.Value);
                }
            });
        }
        catch(e){
            Auth.signOut();
        }
    }

    if (loading){
        return (

            <div class="center_parents">
                <div class="title_text">DSK一覧　＜{location.state.hotelName}＞</div>
                <hr color="#00B4C6" size="6" />
                <br />
                <table class="table_border overall_table">
                    <tr>
                        <td>
                            <div>
                            <img src={loadimg}/>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        );
    }
    return (
        <div class="">
            <div class="title_text">DSK一覧　＜{location.state.hotelName}＞</div>
            <hr color="#00B4C6" size="6" />
            <br />

            <table class="table_border overall_table center">
                <tr class = "">
                    <td class="table_border_updown_thtd_left_titlenumber">
                        No.
                    </td>
                    <td class="table_border_updown_thtd_left_title center" style={{width:"600px"}}>
                        DSK
                    </td>
                </tr>
                <Pagination
                dataList={dskLinks}
                col_count={3}
                numOfLine={numOfLine}
                />
            </table>
        </div>
    );
}

export default Dsk_list;
